import { render, staticRenderFns } from "./BosSayfa.vue?vue&type=template&id=f36a5044&"
import script from "./BosSayfa.vue?vue&type=script&lang=js&"
export * from "./BosSayfa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports